import Vue from 'vue'
export const EventBus = new Vue({
  data: {
    messages: {
      'total': 0,
      'ids': []
    },
    incidents: {
      'total': 0,
      'ids': []
    },
    violations: {
      'total': 0,
      'ids': []
    },
    trips: {
      'total': 0,
      'ids': []
    },
    boarding: {},
    bus_numbers: {},
    recorded: []
  }
})



// WEBPACK FOOTER //
// ./src/event-bus.js